export default __webpack_public_path__ + "static/media/tutorial1-5.3cf6cc66.png";